Vue.component('ack-curo-resins', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-curo-resins',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-curo-resins mounted');
		//this.setPageIsLoading(false)
	},
	props: {},
	computed: {
		...Vuex.mapGetters('articles', ['articlesArray']),
		...Vuex.mapGetters('resins', ['selectedShopifyProduct']),
		...Vuex.mapState('resins', ['selectedProductId']),
		...Vuex.mapGetters('localization', ['isUS_CA', 'isIreland', 'isTW']),
		lastArticles() {
			let arr = [];
			for (let index = 0; index < 3; index++) {
				const element = this.articlesArray[index];
				arr.push(element);
			}
			return arr;
		},
		isMobile() {
			return this.$parent.isMobile;
		},
		productMenuItems() {
			const hideCuroModel = (resin) => resin.id !== 'model';
			const defaultItems = this.curoResinsInfo.product_menu_section.menu_items;
			const usCaItems = defaultItems.filter(hideCuroModel);
			return this.isUS_CA || this.isIreland ? usCaItems : defaultItems;
		},
	},
	data() {
		return {
			pageId: 'resins',
			default_3dps_bundle: 'shop-3dps-6',
			curoResinsInfo: {
				title_section: {
					id: 'curo',
					title: 'resins.main_title',
					subtitle: 'resins.main_title',
					title_img:
						window.ackShopifyFileUrl("Logo_Resize-08.png"),
					description: 'resins.main_description',
					image_desktop:
						window.ackShopifyFileUrl("Website-V4.0-Resins_banner_5b066cdf-7e5d-450c-b8ad-40ad2af16d4c.jpg"),
					image_mobile: null,
					price: 0.0,
					shop_button: 'resins.shop_button',
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
				},
				icons_section: {
					collateral_items: [
						{
							img_src:
								window.ackShopifyFileUrl("UVBox_V4_icon_1.png"),
							title: 'Flyer',
							// link: 'https://cdn.ackuretta.com/downloads/curo/CURO_Flyer_Digital.pdf?v=latest',
							link: 'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/curo/CURO_Flyer_Digital.pdf',
						},
						{
							img_src:
								window.ackShopifyFileUrl("Resin_V4_icon_1Catalog.png"),
							title: 'Booklet',
							// link: 'https://cdn.ackuretta.com/public/curo/Digital_Application%20Booklet.pdf',
							link: 'https://s3.us-east-1.amazonaws.com/ackuretta.website/public/curo/Digital_Application+Booklet.pdf',
						},
						{
							img_src:
								window.ackShopifyFileUrl("Resin_V4_icon_3IFU.png"),
							title: 'CURO IFU',
							link: 'https://cdn.ackuretta.com/downloads/curo/Instructions%20for%20Use.pdf',
						},
						{
							img_src:
								window.ackShopifyFileUrl("Resin_V4_icon_5Shipping.png"),
							title: 'Shipping Restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
						},
					],
				},
				product_menu_section: {
					menu_items: [
						{
							imageMenu:
								window.ackShopifyFileUrl("Resin_V4_Application_icon_1_Model_Ortho_option2.png"),
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_16.png"),
							id: 'ortho-label',
							productId: '6893565673575',
							link: '#ortho',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_1%20Model%20Element.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_1.png"),
							id: 'element',
							productId: '6627069591655',
							link: '#element',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_2%20Model.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_2.png"),
							id: 'model',
							productId: '6624780812391',
							link: '#model',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_4%20Splint.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_4.png"),
							id: 'splint',
							productId: '6627062448231',
							link: '#splint',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_3%20Crown.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_3_f73ca71a-c353-413b-8415-9cd6e07f37d8.png"),
							id: 'crown',
							productId: '6627055435879',
							link: '#crown',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_5%20Denture.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_5.png"),
							id: 'pro-denture',
							productId: '6624785760359',
							link: '#pro-denture',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_6%20Guide.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_6.png"),
							id: 'guide',
							productId: '6624785924199',
							link: '#guide',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_8%20Tray.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_8.png"),
							id: 'tray',
							productId: '6627069427815',
							link: '#tray',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_9%20IBT.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_9.png"),
							id: 'ibt',
							productId: '6600052015207',
							link: '#ibt',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_7%20Cast.png?v=latest',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_7.png"),
							id: 'pro-cast',
							productId: '6626529214567',
							link: '#pro-cast',
						},
						// { imageMenu: 'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_10%20Gingiva.png', imageLogo: window.ackShopifyFileUrl("Resin_V4_Circle_10.png"), id: 'gingiva', productId: "6627058712679", link: '#gingiva' }
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_10%20Gingiva.png',
							imageLogo:
								window.ackShopifyFileUrl("Resin_V4_Circle_11.png"),
							id: 'pro-gingiva',
							productId: '7186312757351',
							link: '#pro-gingiva',
						},
					],
				},
				articles: null,
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'resins.testimonials_section.testimonial_items.testimonial_one.name',
							title: 'resins.testimonials_section.testimonial_items.testimonial_one.title',
							quote: 'resins.testimonials_section.testimonial_items.testimonial_one.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Adam_Nulty.jpg"),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'resins.testimonials_section.testimonial_items.testimonial_two.name',
							title: 'resins.testimonials_section.testimonial_items.testimonial_two.title',
							quote: 'resins.testimonials_section.testimonial_items.testimonial_two.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_-Juliana_Andre.jpg"),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'resins.testimonials_section.testimonial_items.testimonial_three.name',
							title: 'resins.testimonials_section.testimonial_items.testimonial_three.title',
							quote: 'resins.testimonials_section.testimonial_items.testimonial_three.description',
							img_src:
								window.ackShopifyFileUrl("stivetiang.jpg"),
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'Successful Cases',
					media_grid_collection: {
						main_item: {
							title: 'Images provided by Fermín Ocañas',
							description: '',
							img: window.ackShopifyFileUrl("Resin_V4_Successful_Cases_1.jpg"),
						},
						secondary_item: {
							title: 'Images provided by Aleksandar Momani',
							description: '',
							img: window.ackShopifyFileUrl("Resin_V4_Successful_Cases_2.jpg"),
						},
					},
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		...Vuex.mapActions('resins', ['menuItemClick']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		onResinMenuItemClick(item) {
			this.menuItemClick(item.productId);
			this.selectedProductId = item.productId;
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
